import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { truncateTooltip } from "./tooltip.js";
import Tooltip from "../Tooltip/Tooltip.js";
const TextWrapper = styled(Box)(({
  theme
}) => ({
  minWidth: "7rem",
  display: "grid",
  overflow: "hidden",
  textOverflow: "ellipsis",
  padding: theme.sizes.spacing.none
}));
const Text = styled(Typography)(({
  theme
}) => ({
  color: theme.colors.text.primary,
  fontSize: theme.fonts.size.sm,
  fontFamily: theme.fonts.family.body,
  fontWeight: theme.fonts.weight.normal,
  lineHeight: theme.fonts.lineHeight["leading-5"],
  letterSpacing: theme.fonts.letterSpacing.wide
}));
const Link = styled("a")(() => ({
  textDecoration: "none",
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline"
  }
}));
const CellLink = (t0) => {
  const $ = c(10);
  const {
    text,
    url
  } = t0;
  let t1;
  if ($[0] !== text) {
    t1 = truncateTooltip(text);
    $[0] = text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = url ? url : text;
  let t3;
  if ($[2] !== text) {
    t3 = /* @__PURE__ */ jsx(Text, { noWrap: true, variant: "valueCell", children: text });
    $[2] = text;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = /* @__PURE__ */ jsx(Link, { href: t2, target: "_blank", rel: "noopener noreferrer", children: t3 });
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = /* @__PURE__ */ jsx(TextWrapper, { children: /* @__PURE__ */ jsx(Tooltip, { placement: "top", title: t1, children: t4 }) });
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export {
  CellLink as default
};
